// components/LowStockTable.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";

const LowStockTable = ({ products }) => {
  const navigate = useNavigate();

  if (products.length === 0) return null;

  return (
    <div
      id="low-stock-section"
      className="bg-white rounded-lg shadow-sm border border-red-200 p-6"
    >
      <div className="flex items-center gap-3 mb-6">
        <FiAlertTriangle className="text-red-500" size={24} />
        <h3 className="text-xl font-bold text-gray-900">
          Low Stock & Out of Stock Products
        </h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">
                Product Name
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">
                Current Stock
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr
                key={product._id}
                className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
              >
                <td className="py-4 px-4 text-sm font-medium text-gray-900">
                  {product.name}
                </td>
                <td className="py-4 px-4">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-bold ${
                      product.stock === 0
                        ? "bg-red-100 text-red-700"
                        : product.stock <= 3
                        ? "bg-orange-100 text-orange-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {product.stock} units
                  </span>
                </td>
                <td className="py-4 px-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-semibold ${
                      product.stock === 0
                        ? "bg-red-100 text-red-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {product.stock === 0 ? "OUT OF STOCK" : "LOW STOCK"}
                  </span>
                </td>
                <td className="py-4 px-4">
                  <button
                    onClick={() =>
                      navigate(`/dashboard/admin/product/${product.slug}`)
                    }
                    className="text-gray-900 hover:text-gray-600 font-semibold text-sm underline"
                  >
                    Update Stock
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LowStockTable;
